import React, { useState, useEffect } from "react";
import Navbar from "../Home/NavBar/Navbar";
import Events from "./EventsPage/EventsPage";
import Footer from "../Home/Footer/Footer";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import AffordablePricing from "../Home/AffordablePricing/AffordablePricing";

export default function MainSearchPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [filters, setFilters] = useState({
    eventName: "",
    location: "",
    dateRange: [],
  });

  const eventName = queryParams.get("eventName") || "";
  useEffect(() => {
    // Extract query parameters
    const startDate = queryParams.get("startDate")
      ? new Date(queryParams.get("startDate"))
      : null;
    const endDate = queryParams.get("endDate")
      ? new Date(queryParams.get("endDate"))
      : null;
    // const dateRange = startDate && endDate ? [startDate, endDate] : [];
    const dateRange = [
      startDate instanceof Date && !isNaN(startDate) ? startDate : null,
      endDate instanceof Date && !isNaN(endDate) ? endDate : null,
    ];

    setFilters({
      eventName,
      location: "",
      dateRange,
    });
  }, [location.search]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <>
      <Box
        sx={{
          paddingLeft: "25px",
          paddingRight: "25px",
          boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        }}
      >
        <Navbar />
      </Box>

      <Events filters={filters} onFilterChange={handleFilterChange} />

      <Box sx={{ mt: { xs: 10, md: 15 } }}>
        <AffordablePricing />
      </Box>

      <Box sx={{ mt: { xs: 10, md: 20 } }}>
        <Footer />
      </Box>
    </>
  );
}
